import { Component, Input, OnInit } from '@angular/core';
import { LocalesService, ConfigService } from './locales.service';
import { Observable } from 'rxjs';
import { Locale, Replacement } from './Locale';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-locale',
  template: `
    <span *ngIf="locale?.contentType === 'text/plain'" [attr.title]="showTitle ? locale?.value : null">{{locale?.value}}</span>
    <span *ngIf="locale?.contentType === 'text/html'" [attr.title]="showTitle ? locale?.value : null">
      <span [innerHtml] = 'locale?.value'></span>
    </span>`
})
export class LocaleComponent implements OnInit {
  @Input() localeKey: string;
  @Input() localeView: string = null;
  @Input() showTitle: boolean = false;
  @Input() set replacement(value: Replacement) {
    this._replacement = value;
    this.doReplacements();
  };
  
  observableLocale: Observable<Locale>;
  private _replacement: Replacement;
  locale: Locale;
  constructor(private localeService: LocalesService, private configService: ConfigService) { }

  ngOnInit() {
    this.setLocale();
  }

  getLocaleString(): void {
    this.localeService.getLocaleStringObservable(this.configService.languagerequested, this.localeKey, this.localeView).subscribe((val: Locale) => {
      this.locale = { ...val };
      this.doReplacements();
    });
  }

  setLocale() {
   this.getLocaleString();
  }

  doReplacements(): void {
    if (this._replacement && this.locale) {
      this.locale.value = this.locale.value.replace(this._replacement.replaceText, this._replacement.value);
     
    }
  }
}
